import React from "react";

const ChevronRight = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      stroke="currentColor"
      d="M8 1l8 11-8 11"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronRight;



// WEBPACK FOOTER //
// ./src/theme/icons/ChevronRight.js